import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error("Erreur d'affichage", error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground" data-testid="error-boundary">
        <div className="max-w-md space-y-4 rounded-2xl border border-border bg-card p-6 text-center">
          <h1 className="font-display text-xl font-bold">Oups, l'affichage s'est interrompu</h1>
          <p className="text-sm text-muted-foreground">
            Si la traduction automatique du navigateur est active, désactivez-la pour ce site (icône de traduction dans la barre d'adresse → « Ne jamais traduire »).
            Vos données enregistrées ne sont pas perdues.
          </p>
          <button onClick={() => window.location.reload()} data-testid="error-reload-button"
            className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground">Recharger la page</button>
        </div>
      </div>
    );
  }
}
